/* eslint-disable no-template-curly-in-string */
import R from 'ramda'

const SEND_DARK_TWEET_ACTION_TYPE = 'SEND_DARK_TWEET'
const SEND_DARK_TWEET_DISPLAY_TYPE = 'Send Tweet'

const isSendDarkTweetFormAction = R.propEq('type', SEND_DARK_TWEET_DISPLAY_TYPE)
const convertToInteger = value => parseInt(value, 10)

const convertSendDarkTweetFormActionToWidgetAction = R.pipe(
  R.applySpec({
    type: R.always(SEND_DARK_TWEET_ACTION_TYPE),
    attachmentUrl: R.ifElse(
      R.prop('isRandomResponse'),
      R.always(undefined),
      R.prop('attachmentUrl')
    ),
    cardUri: R.prop('cardUri'),
    media: R.ifElse(
      R.prop('isRandomResponse'),
      R.always(undefined),
      R.prop('media')
    ),
    tweetMediaIds: R.ifElse(
      R.prop('isRandomResponse'),
      R.propOr([], 'tweetMediaIds'),
      R.always(undefined)
    ),
    message: R.ifElse(
      R.prop('isRandomResponse'),
      R.always('@${senderHandle}'),
      R.prop('message')
    ),
    randomResponsePoolId: R.ifElse(
      R.prop('isRandomResponse'),
      R.propOr('', 'randomResponsePoolId'),
      R.always(undefined)
    ),
    randomResponseTweetIds: R.ifElse(
      R.prop('isRandomResponse'),
      R.propOr([], 'randomResponseTweetIds'),
      R.always(undefined)
    ),
    allowMultiple: R.ifElse(
      R.prop('isRandomResponse'),
      R.propOr(false, 'allowMultiple'),
      R.always(undefined)
    ),
    isRandomResponse: R.ifElse(
      R.prop('isRandomResponse'),
      R.prop('isRandomResponse'),
      R.always(undefined)
    ),
    isMosaicConsent: R.ifElse(
      R.prop('isMosaicConsent'),
      R.prop('isMosaicConsent'),
      R.always(undefined)
    ),
    responseCap: R.ifElse(
      R.prop('hasResponseCap'),
      R.pipe(R.prop('responseCap'), convertToInteger),
      R.always(undefined)
    ),
    isSequential: R.ifElse(
      R.prop('isSequential'),
      R.prop('isSequential'),
      R.always(undefined)
    ),
    allowResponseTriggers: R.ifElse(
      R.prop('allowResponseTriggers'),
      R.prop('allowResponseTriggers'),
      R.always(undefined)
    )
  }),
  R.pickBy(R.complement(R.isNil))
)

export {
  isSendDarkTweetFormAction,
  convertSendDarkTweetFormActionToWidgetAction
}



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/twitter/form-to-widget/send-dark-tweet.js